export default function Footer() {
    return (
        <div className='appFooter'>
            Made with love by Esmeralda
        </div>
    )
}